import { render, staticRenderFns } from "./LeftNavbar.vue?vue&type=template&id=906c2d56&"
import script from "./LeftNavbar.vue?vue&type=script&lang=js&"
export * from "./LeftNavbar.vue?vue&type=script&lang=js&"
import style0 from "./LeftNavbar.vue?vue&type=style&index=0&id=906c2d56&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports